import React from "react";
import {
  convertRupeesToWords,
  roundOffCost,
  roundOffCostWithoutRupee,
} from "../../../Components/Functions/amt.fun";

const InvoiceDetails = ({ data }) => {
  let finalAmount = 0;
  let finalAmountWithGST = 0;
  let gstAmt = 0;

  // Calculate totals for each line item
  data.lineItems &&
    data.lineItems.forEach((lineItem) => {
      const itemTotal = +lineItem.itemPrice * +lineItem.itemQuantity;
      const itemGST = (itemTotal * (lineItem.gstRate || 0)) / 100;
      finalAmount += itemTotal;
      gstAmt += itemGST;
      finalAmountWithGST += itemTotal + itemGST;
    });

  let wordamt = roundOffCostWithoutRupee(finalAmountWithGST);

  return (
    <div>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          border: "1px solid #181818",
        }}
      >
        <thead style={{ backgroundColor: "#e8e9eb" }}>
          <tr>
            <td
              style={{
                width: "2%",
                border: "1px solid #181818",
                textAlign: "center",
                fontWeight: "bolder",
              }}
              className="p-1 fs-4"
            >
              Sr.
            </td>
            <td
              className="p-1 fs-4"
              style={{
                width: "20%",
                textAlign: "center",
                border: "1px solid #181818",
                fontWeight: "bolder",
              }}
            >
              Particulars
            </td>

            <td
              className="p-1  fs-4"
              style={{
                width: "7%",
                textAlign: "center",
                border: "1px solid #181818",
                fontWeight: "bolder",
              }}
            >
              Size/Qty
            </td>
            <td
              className="p-1  fs-4"
              style={{
                width: "10%",
                textAlign: "center",
                border: "1px solid #181818",
                fontWeight: "bolder",
              }}
            >
              HSN
            </td>
            <td
              className="p-1  fs-4"
              style={{
                width: "8%",
                textAlign: "center",
                border: "1px solid #181818",
                fontWeight: "bolder",
              }}
            >
              Amount
            </td>

            {data?.billingAddress?.state === "Maharashtra" && (
              <td
                style={{
                  width: "10%",
                  textAlign: "center",
                  border: "1px solid #181818",
                  fontWeight: "bolder",
                }}
              >
                CGST %
              </td>
            )}
            {data?.billingAddress?.state === "Maharashtra" && (
              <td
                style={{
                  width: "10%",
                  textAlign: "center",
                  border: "1px solid #181818",
                  fontWeight: "bolder",
                }}
              >
                CGST AMT
              </td>
            )}
            {data?.billingAddress?.state === "Maharashtra" && (
              <td
                style={{
                  width: "10%",
                  textAlign: "center",
                  border: "1px solid #181818",
                  fontWeight: "bolder",
                }}
              >
                SGST %
              </td>
            )}
            {data?.billingAddress?.state === "Maharashtra" && (
              <td
                style={{
                  width: "10%",
                  textAlign: "center",
                  border: "1px solid #181818",
                  fontWeight: "bolder",
                }}
              >
                SGST AMT
              </td>
            )}
            {data?.billingAddress?.state !== "Maharashtra" && (
              <td
                style={{
                  width: "10%",
                  textAlign: "center",
                  border: "1px solid #181818",
                  fontWeight: "bolder",
                }}
              >
                IGST %
              </td>
            )}
            {data?.billingAddress?.state !== "Maharashtra" && (
              <td
                style={{
                  width: "10%",
                  textAlign: "center",
                  border: "1px solid #181818",
                  fontWeight: "bolder",
                }}
              >
                IGST Amount
              </td>
            )}
            <td
              className="p-1  fs-4"
              style={{
                width: "15%",
                textAlign: "center",
                border: "1px solid #181818",
                fontWeight: "bolder",
              }}
            >
              Total
            </td>
          </tr>
        </thead>

        <tbody>
          {data?.lineItems?.map((lineItem, index) => {
            const itemTotal = +lineItem.itemPrice * +lineItem.itemQuantity;
            const itemGST = (itemTotal * (lineItem.gstRate || 0)) / 100;
            const totalWithGST = itemTotal + itemGST;

            return (
              <tr key={index}>
                <td
                  className="p-1  fs-4"
                  style={{ border: "1px solid #181818" }}
                >
                  {index + 1}
                </td>
                <td
                  className="p-1  fs-4"
                  style={{ border: "1px solid #181818" }}
                >
                  {lineItem?.particulars || "-"}
                </td>

                <td
                  className="p-1  fs-4"
                  style={{ border: "1px solid #181818" }}
                >
                  {lineItem?.itemQuantity || "-"} {lineItem?.itemUnit}
                </td>
                <td
                  className="p-1  fs-4"
                  style={{ border: "1px solid #181818" }}
                >
                  {lineItem?.HSN || "-"}
                </td>
                <td
                  className="p-1  fs-4"
                  style={{ border: "1px solid #181818" }}
                >
                  {roundOffCost(itemTotal)}
                </td>
                {data?.billingAddress?.state !== "Maharashtra" && (
                  <td style={{ border: "1px solid #181818" }}>
                    {`${lineItem?.gstRate}.0 %`}
                  </td>
                )}
                {data?.billingAddress?.state !== "Maharashtra" && (
                  <td style={{ border: "1px solid #181818" }}>
                    {roundOffCost(itemGST)}
                  </td>
                )}
                {data?.billingAddress?.state === "Maharashtra" && (
                  <td style={{ border: "1px solid #181818" }}>
                    {`${(lineItem?.gstRate / 2)?.toFixed(1)} %`}
                  </td>
                )}
                {data?.billingAddress?.state === "Maharashtra" && (
                  <td style={{ border: "1px solid #181818" }}>
                    {roundOffCost(itemGST / 2)}
                  </td>
                )}
                {data?.billingAddress?.state === "Maharashtra" && (
                  <td style={{ border: "1px solid #181818" }}>
                    {`${(lineItem?.gstRate / 2)?.toFixed(1)} %`}
                  </td>
                )}
                {data?.billingAddress?.state === "Maharashtra" && (
                  <td style={{ border: "1px solid #181818" }}>
                    {roundOffCost(itemGST / 2)}
                  </td>
                )}

                <td style={{ border: "1px solid #181818" }}>
                  {roundOffCost(totalWithGST)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <table style={{ width: "100%", border: "none", marginTop: "2px" }}>
        <tbody>
          <tr style={{ border: "none" }}>
            <td
              style={{
                border: "none",
                width: "60%",
                verticalAlign: "top",
                padding: "3px",
              }}
            >
              <p style={{ padding: "5px" }}>
                <span className="fs-3">In Words:</span>{" "}
                <b style={{ fontSize: "0.9rem" }}>
                  {convertRupeesToWords(wordamt)}
                </b>
              </p>
            </td>
            <td
              className="ps-1"
              style={{
                border: "none",
                width: "40%",
                verticalAlign: "top",
                padding: "0",
              }}
            >
              <table
                style={{
                  width: "99%",
                  borderCollapse: "collapse",
                  marginTop: "2px",
                  marginBottom: "2px",
                }}
              >
                <tbody>
                  <tr className="fs-3">
                    <td
                      className="fs-4"
                      style={{ border: "1px solid #181818", padding: "3px" }}
                    >
                      Amount
                    </td>
                    <td
                      className="fs-4"
                      style={{ border: "1px solid #181818", padding: "3px" }}
                    >
                      {roundOffCost(finalAmount)}
                    </td>
                  </tr>
                  {data?.billingAddress?.state !== "Maharashtra" && (
                    <tr>
                      <td
                        className="fs-4"
                        style={{ border: "1px solid #181818", padding: "3px" }}
                      >
                        IGST
                      </td>
                      <td
                        className="fs-4"
                        style={{ border: "1px solid #181818", padding: "3px" }}
                      >
                        {roundOffCost(gstAmt)}
                      </td>
                    </tr>
                  )}
                  {data?.billingAddress?.state === "Maharashtra" && (
                    <tr>
                      <td
                        className="fs-4"
                        style={{ border: "1px solid #181818", padding: "3px" }}
                      >
                        CGST
                      </td>
                      <td
                        className="fs-4"
                        style={{ border: "1px solid #181818", padding: "3px" }}
                      >
                        {roundOffCost(gstAmt / 2)}
                      </td>
                    </tr>
                  )}
                  {data?.billingAddress?.state === "Maharashtra" && (
                    <tr>
                      <td
                        style={{ border: "1px solid #181818", padding: "3px" }}
                      >
                        SGST
                      </td>
                      <td
                        style={{ border: "1px solid #181818", padding: "3px" }}
                      >
                        {roundOffCost(gstAmt / 2)}
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td style={{ border: "1px solid #181818", padding: "3px" }}>
                      Total
                    </td>
                    <td
                      className="fs-4"
                      style={{ border: "1px solid #181818", padding: "3px" }}
                    >
                      {roundOffCost(finalAmountWithGST)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default InvoiceDetails;
